import { v4 as uuid } from 'uuid';

const instance_id = uuid();

export default instance_id;
